const Cookie = {
  tld: false, // if true, set cookie domain at top level domain
  set (name, value, {days, path}) {
    let cookie = {[name]: value, path: path || '/'};

    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      cookie.expires = date.toUTCString();
    }

    if (Cookie.tld) {
      cookie.domain = '.' + window.location.hostname.split('.').slice(-2).join('.');
    }

    let arr = [];
    for (let key in cookie) {
      arr.push(`${key}=${cookie[key]}`);
    }
    document.cookie = arr.join('; ');

    return this.get(name);
  },

  getAll () {
    return document.cookie.split(';').reduce((acc, el) => {
      let [k, v] = el.split('=');
      acc[decodeURIComponent(k.trim())] = decodeURIComponent(v);
      return acc;
    }, {});
  },

  get (name) {
    return this.getAll()[name];
  },

  delete (name) {
    this.set(name, '', -1);
  },
};
export default Cookie;



// WEBPACK FOOTER //
// ./src/services/cookie.js